export enum SideMenuState {
    open=0,
    toggle=1,
    close=2,
    over=3
}
